import { FeaturedProject } from "config"
import MetadataAwareTokenView from "components/MetadataAwareTokenView"
import { ArtBlocksProjectMetadataToken } from "utils/artBlocksMetadataApi"

interface Props {
  tokens: ArtBlocksProjectMetadataToken[]
  tokenWidth: number
  fallbackAspectRatio: number
  renderMode?: "image" | "live"
  project?: FeaturedProject
  contractAddress?: string
  chainId?: number
  getTokenHref: (token: ArtBlocksProjectMetadataToken) => string
}

const MetadataTokenGrid = ({
  tokens,
  tokenWidth,
  fallbackAspectRatio,
  renderMode = "image",
  project,
  contractAddress,
  chainId,
  getTokenHref,
}: Props) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
    {tokens.map((token) => (
      <a
        key={token.id}
        href={getTokenHref(token)}
        className="gallery-card block h-full group"
      >
        <div className="gallery-card-art min-h-0">
          <div className="transition-transform duration-500 group-hover:scale-[1.015]">
            <MetadataAwareTokenView
              project={project}
              contractAddress={project ? undefined : contractAddress}
              tokenId={token.token_id}
              chainId={project ? undefined : chainId}
              width={tokenWidth}
              fallbackAspectRatio={fallbackAspectRatio}
              live={renderMode === "live"}
            />
          </div>
        </div>
        <div className="gallery-card-body gap-3">
          <div className="flex items-center justify-between gap-3">
            <h3 className="gallery-label text-gallery-text">No. {token.invocation}</h3>
          </div>
          <p className="text-xs text-gallery-muted break-all">{token.token_id}</p>
        </div>
      </a>
    ))}
  </div>
)

export default MetadataTokenGrid
